import { useEffect } from 'react';

import { removeFromAgendaQueueAction } from 'actions/addConsumeAgendaActions';
import { addAgendaAction } from 'actions/agenda';
import { Agenda } from 'models/agenda';
import { BasicEmployee } from 'models/employee';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { AGENDA_STATUSES } from 'constants/ProjectConstants';
import { generateKey } from 'constants/helper';

import { addToAgenda, createAgenda } from 'services/agenda';
import { showErrorSnackbar } from 'services/snackbar';

const useConsumeAgendaFromQueue = ({ agendasDispatch, setBusy, updatePagination, checkInInstanceId, questionId }) => {
  const dispatch = useDispatch();
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData, shallowEqual);
  const { agendaQueue } = useSelector((state) => state.addToAgendaState, shallowEqual);

  useEffect(() => {
    if (agendaQueue.length > 0) {
      // consume the agenda.

      const agendaLabel = agendaQueue?.[0];

      if (!agendaLabel) return;

      const { isTagged, uuid, labelType, text, levelUpInfo } = agendaLabel;

      const uiKey = generateKey(7);

      setBusy(true);
      updatePagination({ page: 1 });

      dispatch(
        removeFromAgendaQueueAction({
          uuid,
        })
      );

      if (isTagged) {
        addToAgenda({
          checkInInstanceId,
          questionId,
          label: { labelType, uuid },
          levelUpInfo,
          uiKey,
        })
          .then((createdAgenda) => {
            createdAgenda.isEditing = false;
            createdAgenda.uiKey = uiKey;
            agendasDispatch(addAgendaAction(createdAgenda));
          })
          .catch((err) => dispatch(showErrorSnackbar(err.message || 'Sorry! An error occured adding the agenda')))
          .finally(() => setBusy(false));
      } else if (text) {
        const { id, displayName, designation, profilePhotoSrc } = loggedInEmployee;

        const newAgenda = Agenda.fromJSON({
          uuid: null,
          text,
          status: AGENDA_STATUSES.active,
          macros: null,
          uiKey: generateKey(7),
          fromEmployee: new BasicEmployee({
            id,
            displayName,
            designation,
            profilePhotoSrc,
          }),
          label: null,
        });

        createAgenda({
          ...newAgenda,
          checkInInstanceId,
          questionId,
        })
          .then((createdAgenda) => {
            createdAgenda.isEditing = false;
            // Making sure that if this was a new agenda, it has a key of that one
            createdAgenda.uiKey = newAgenda.uiKey;
            // getData();
            agendasDispatch(addAgendaAction(createdAgenda));
          })
          .catch((err) =>
            dispatch(showErrorSnackbar(err.message || 'Sorry! An error occured while creating the agenda'))
          )
          .finally(() => setBusy(false));
      }
    }
  }, [agendaQueue]);
};

export default useConsumeAgendaFromQueue;
